module.exports = __webpack_public_path__ + "img/faqs-hero-c2ce9c4.jpg";